const env = {
    locale: 'en-gb',
    shortDateFormat: 'dd/MM/yyyy',
    shortDatePlaceholder: 'DD/MM/YYYY'
};

export default env;